
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/vorur",
      function () {
        return require("private-next-pages/um/thjonusta/vorur.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/vorur"])
      });
    }
  